module.exports = __webpack_public_path__ + "static/img/safari.27f7949.png";


//////////////////
// WEBPACK FOOTER
// ./static/ios/safari.png
// module id = bI1V
// module chunks = 0